<template>
  <nav class="navbar" :class="{ scrolled: scrollPosition > 150 }">
    <section class="main_nav">
      <div class="main_nav_content">
        <img
          class="menu__logo logo-white mobileLogo"
          src="@/assets/images/header/primary-white.svg"
        />
        <img
          class="menu__logo logo-black mobileLogo"
          src="@/assets/images/header/primary-black.svg"
        />
        <button
          type="button"
          class="burger"
          :class="{ active: isActive }"
          @click="toggleBurger"
        >
          <span class="burger-line"></span>
          <span class="burger-line"></span>
          <span class="burger-line"></span>
          <span class="burger-line"></span>
        </button>
        <div class="menu" :class="{ active: isActive }" ref="menuRef">
          <img
            class="menu__logo logo-white desktopLogo"
            src="@/assets/images/header/primary-white.svg"
          />
          <img
            class="menu__logo logo-black desktopLogo"
            src="@/assets/images/header/primary-black.svg"
          />
          <ul class="menu-inner" v-scroll-spy-active v-scroll-spy-link>
            <li class="menu-item">
              <a href="#" v-scroll-to="'#hero'" class="menu-link">Home</a>
            </li>
            <li class="menu-item" @click="toggleBurger">
              <a href="#" v-scroll-to="'#Introduction'" class="menu-link"
                >Introduction</a
              >
            </li>
            <li class="menu-item" @click="toggleBurger">
              <a href="#" class="menu-link" v-scroll-to="'#Benefits'"
                >Incentives</a
              >
            </li>
            <li class="menu-item" @click="toggleBurger">
              <a href="#" class="menu-link" v-scroll-to="'#account_summary'"
                >Account Summary</a
              >
            </li>
            <li class="menu-item" @click="toggleBurger">
              <a href="#" class="menu-link" v-scroll-to="'#SeatingMap'"
                >seating map</a
              >
            </li>
            <li class="menu-item" @click="toggleBurger">
              <a href="#" class="menu-link" v-scroll-to="'#incentives'"
                >renewal benefits</a
              >
            </li>
            <li class="menu-item" @click="toggleBurger">
              <a href="#" class="menu-link" v-scroll-to="'#faq'">renewal faq</a>
            </li>
          </ul>
          <a
            class="renewMobile"
            href="https://am.ticketmaster.com/pistons/"
            target="_blank"
            @click="store.dispatch('purl/purlTracking', 'Renew Now')"
            >renew now</a
          >
        </div>
        <div class="links">
          <a
            class="renew"
            href="https://am.ticketmaster.com/pistons/"
            target="_blank"
            @click="store.dispatch('purl/purlTracking', 'Renew Now')"
            >renew now</a
          >
        </div>
      </div>
    </section>
  </nav>
</template>

<script>
import { ref, reactive, watch, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "Header",
  data() {
    return {
      scrollPosition: null,
    };
  },
  setup() {
    const menuRef = ref();
    const store = useStore();

    // State
    const state = reactive({
      isActive: false,
      theme: computed(() => store.getters["dom/getTheme"]),
      logoSrc: computed(() =>
        store.getters["dom/getTheme"] === "light"
          ? "logo.png"
          : "logo-white.png"
      ),
    });

    watch(state, () => {
      if (state.isActive) {
        let height = window.innerHeight;
        menuRef.value.style.maxHeight = height + "px";
      } else {
        menuRef.value.removeAttribute("style");
      }
    });

    // Methods
    function toggleBurger() {
      state.isActive = !state.isActive;
    }
    // function modeToggle() {
    //   const mode = state.theme === "light" ? "dark" : "light";
    //   store.commit("dom/SET_THEME", mode);
    // }
    return {
      ...toRefs(state),
      toggleBurger,
      menuRef,
      store,
      // modeToggle,
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
  mounted() {
    this.updateScroll();
    window.addEventListener("scroll", this.updateScroll);
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  margin: 0 auto;
  padding: 0;
  border: none;
  outline: none;
  position: fixed;
  height: 84px;
  width: 100%;
  max-width: 100%;
  top: 0;
  z-index: 10;
  background: transparent;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: url("~@/assets/images/header/scrolled-menu-bg.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    opacity: 0;
    transition: opacity 0.35s ease-in-out;
    @media (max-width: 992px) {
      background: url("~@/assets/images/header/brick-pattern-bg.jpg");
    }
  }
  &.scrolled {
    &::before {
      opacity: 1;
      transition: opacity 0.35s ease-in-out;
    }
    .menu-link {
      color: #1a1919 !important;
      @media (max-width: 992px) {
        color: #ffffff !important;
      }
    }
    .logo-white {
      @media (min-width: 992px) {
        display: none !important;
      }
    }
    .logo-black {
      @media (min-width: 992px) {
        display: block !important;
      }
    }
    .mobileLogo {
      @media (min-width: 992px) {
        display: none !important;
      }
    }
    &.router-link-active,
    &:hover {
      .menu-link {
        color: #1a1919 !important;
        @media (max-width: 992px) {
          color: #ffffff !important;
        }
      }
    }
    &.active .menu-link {
      color: #1a1919 !important;
      @media (max-width: 992px) {
        color: #ffffff !important;
      }
    }
  }
  .main_nav {
    position: relative;
    width: 100%;
    height: 100%;
    &_content {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .menu {
      width: 100%;
      height: 84px;
      display: flex;
      align-items: center;
      padding-left: 31px;
      @media (max-width: 992px) {
        flex-direction: column;
        background: url("~@/assets/images/header/brick-pattern-bg.jpg");
        background-repeat: no-repeat;
        background-size: cover;
      }
      &.active {
        @media (max-width: 992px) {
          height: 100vh;
          padding-left: 0;
        }
      }
      &__logo {
        height: 68px;
        object-fit: contain;
        &.logo-white {
          display: block;
        }
        &.logo-black {
          display: none;
        }
        &.desktopLogo {
          @media (max-width: 992px) {
            display: none;
          }
        }
        &.mobileLogo {
          position: absolute;
          top: 14px;
          left: 18px;
          height: 59px;
          object-fit: contain;
          @media (min-width: 992px) {
            display: none;
          }
        }
      }
      &-item {
        text-align: center;
        padding: 0.5em 1px;
        &.router-link-active,
        &:hover {
          .menu-link {
            border-bottom: 4px solid #de1e35;
            color: #ffffff;
          }
        }
        &.active .menu-link {
          border-bottom: 4px solid #de1e35;
          color: #ffffff;
        }
      }
      &-link {
        font-family: Abolition;
        border: none;
        text-transform: uppercase;
        text-decoration: none;
        text-rendering: optimizeLegibility;
        transition: all 0.35s ease-in-out;
        font-size: 18px;
        font-style: normal;
        line-height: 21px;
        letter-spacing: 0.45px;
        color: #ffffff;
        text-align: center;
        padding-bottom: 6px;
        @media (max-width: 992px) {
          font-size: 40px;
          line-height: 48px;
        }
      }
      &-inner {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        list-style: none;
        margin: 0;
        @include media-breakpoint-down(lg) {
          flex-direction: column;
          gap: 0;
          width: 100%;
          padding: 0;
        }
      }
      .renewMobile {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 38px;
        width: 128px;
        background: #de1e35;
        font-family: Abolition;
        font-weight: normal;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: normal;
        color: #ffffff;
        text-decoration: none;
        margin-top: 50px;
        @media (min-width: 992px) {
          display: none;
        }
      }
    }
    .links {
      display: flex;
      flex-direction: row;
      justify-content: center;
      height: 100%;
      @media (max-width: 992px) {
        display: none;
      }
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 38px;
        padding: 0 25px;
        white-space: nowrap;
        background: #de1e35;
        font-family: Abolition;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: normal;
        color: #ffffff;
        text-decoration: none;
        &.renew {
          margin-right: 32px;
        }
      }
    }
  }

  .burger {
    position: absolute;
    display: none;
    cursor: pointer;
    width: 2rem;
    height: 1rem;
    border: none;
    outline: none;
    opacity: 0;
    visibility: hidden;
    background: none;
    transform: rotate(0deg);
    transition: 0.35s ease-in-out;
    top: 34px;
    right: 20px;
    @include media-breakpoint-down(lg) {
      display: block;
      opacity: 1;
      visibility: visible;
    }
    &-line {
      display: block;
      position: absolute;
      width: 100%;
      height: 4px;
      left: 0;
      border: none;
      outline: none;
      opacity: 1;
      background: white;
      transform: rotate(0deg);
      transition: 0.25s ease-in-out;

      &:nth-child(1) {
        top: 0;
      }

      &:nth-child(2),
      &:nth-child(3) {
        top: 0.5rem;
      }

      &:nth-child(4) {
        top: 1rem;
      }
    }

    &.active {
      .burger-line {
        &:nth-child(1),
        &:nth-child(4) {
          top: 1.25rem;
          width: 0%;
          left: 50%;
        }

        &:nth-child(2) {
          transform: rotate(45deg);
        }

        &:nth-child(3) {
          transform: rotate(-45deg);
        }
      }
    }
  }

  .menu {
    @include media-breakpoint-down(lg) {
      width: 100%;
      max-height: 0rem;
      padding: 0;
      opacity: 0;
      visibility: hidden;
      overflow: hidden;
      transition: all 0.35s ease;
      justify-content: center;
      align-items: flex-start;
    }
    &.active {
      @include media-breakpoint-down(lg) {
        opacity: 1;
        visibility: visible;
      }
    }
    &-inner {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 2rem;
      list-style: none;
      margin: 0;
      @include media-breakpoint-down(lg) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 0.75rem;
        padding: 1rem 0;
      }
    }
    &-link {
      font-size: 0.7rem;
      font-weight: 500;
      line-height: inherit;
      border: none;
      text-transform: uppercase;
      text-decoration: none;
      text-rendering: optimizeLegibility;
      transition: all 0.35s ease-in-out;
      color: theme-var($--ch-theme-on-secondary);
      &.router-link-active,
      &:hover {
        border: none;
        outline: none;
        color: theme-var($--ch-theme-highlight);
      }
      @include media-breakpoint-down(lg) {
        width: 100%;
        br {
          display: none;
        }
      }
    }
  }
  .mode-toggle {
    position: relative;
    //margin: auto .5rem .5rem auto;
    padding: 0;
    width: 44px;
    height: 24px;
    min-width: 36px;
    min-height: 20px;
    background-color: theme-var($--ch-theme-secondary);
    border: 0;
    border-radius: 24px;
    outline: 0;
    overflow: hidden;
    cursor: pointer;
    z-index: 2;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-touch-callout: none;
    appearance: none;
    transition: background-color 0.5s ease;
    margin-left: 20px;
    .toggle {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 3px solid transparent;
      box-shadow: inset 0 0 0 2px theme-var($--ch-theme-on-secondary);
      overflow: hidden;
      transition: transform 0.5s ease;
      &:before {
        content: "";
        position: relative;
        width: 100%;
        height: 100%;
        left: 50%;
        float: left;
        background-color: theme-var($--ch-theme-on-secondary);
        transition: border-radius 0.5s ease, width 0.5s ease, height 0.5s ease,
          left 0.5s ease, transform 0.5s ease;
      }
    }
    &.dark {
      // background-color: theme-var($--ch-theme-secondary);
      .toggle {
        transform: translateX(19px);
        &:before {
          border-radius: 50%;
          width: 150%;
          height: 85%;
          left: 40%;
          transform: translate(-10%, -40%), rotate(-35deg);
        }
      }
    }
  }
}
</style>
